import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {TitleFromQuery} from '@appComponents/TitleFromQuery';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import mapModulesToProps from '@utils/mapModulesToProps';
import {RenderBackToListButton} from '@modules/product/utils/productLayoutHelper';
import ProductEdit from '@modules/product/views/ProductEdit';
import navigation from '@constants/navigation';
import {routes} from '@constants/routes';
import {GetProductName} from '@graphql/product/query';

export const ProductLayout = ({
    match: {
        params: {
            id = null,
        },
    },
    Menu,
}) => {

    React.useEffect(() => {
        Menu.storeMenu(navigation.eventAdministration.key);
    }, []);

    return (
        <div>
            <HeaderRenderer
                pageTitle={
                    <TitleFromQuery
                        query={GetProductName}
                        variables={{id}}
                        errorBackLink={routes.products.index.path}
                        path={'product.name'}
                        entity={'product'}
                    />
                }
                messagesBoxNames={'productMessageError'}
                buttons={RenderBackToListButton}
            />
            {
                <ProductEdit/>
            }
        </div>
    );
};
ProductLayout.propTypes = {
    Menu: PropTypes.object.isRequired,
    Modal: PropTypes.object.isRequired,
    match: PropTypes.object,
};
ProductLayout.displayName = 'ProductLayout';

export default connect(null, mapModulesToProps(['Menu']))(ProductLayout);
